/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCustomListRecord } from './InternalApiCustomListRecord';
import {
    InternalApiCustomListRecordFromJSON,
    InternalApiCustomListRecordFromJSONTyped,
    InternalApiCustomListRecordToJSON,
    InternalApiCustomListRecordToJSONTyped,
} from './InternalApiCustomListRecord';

/**
 * 
 * @export
 * @interface InternalApiCustomListRecordPage
 */
export interface InternalApiCustomListRecordPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCustomListRecordPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCustomListRecordPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCustomListRecordPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiCustomListRecord>}
     * @memberof InternalApiCustomListRecordPage
     */
    content: Array<InternalApiCustomListRecord>;
}

/**
 * Check if a given object implements the InternalApiCustomListRecordPage interface.
 */
export function instanceOfInternalApiCustomListRecordPage(value: object): value is InternalApiCustomListRecordPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiCustomListRecordPageFromJSON(json: any): InternalApiCustomListRecordPage {
    return InternalApiCustomListRecordPageFromJSONTyped(json, false);
}

export function InternalApiCustomListRecordPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListRecordPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiCustomListRecordFromJSON)),
    };
}

export function InternalApiCustomListRecordPageToJSON(json: any): InternalApiCustomListRecordPage {
    return InternalApiCustomListRecordPageToJSONTyped(json, false);
}

export function InternalApiCustomListRecordPageToJSONTyped(value?: InternalApiCustomListRecordPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiCustomListRecordToJSON)),
    };
}

